module.exports = __webpack_public_path__ + "img/SpeedOutlined.eab72178.svg";